/**
 * utils/isPremium.js
 *
 * Single source of truth for the premium status check in JS.
 *
 * PHP injects this via wp_localize_script:
 *   wp_localize_script( 'apafw-form-builder', 'WPBean_PA_CONFIG', [
 *       'is_premium' => wpbean_pa_fs()->is_paying_or_trial(),
 *   ]);
 *
 * Usage:
 *   import { isPremium, canUseField } from '../utils/isPremium';
 *
 *   if ( isPremium() ) { ... }
 *   if ( canUseField(definition) ) { ... }
 */

/** Returns true when the current site has an active premium licence. */
export const isPremium = () => Boolean(window.WPBean_PGS_Options?.is_premium);

/**
 * Returns true when a field definition is usable on the current licence.
 * Free fields (no isPremium flag) are always usable.
 */
export const canUseField = (definition) => !definition.isPremium || isPremium();
